import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6aa88b83"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]
const _hoisted_4 = ["src"]


export default /*#__PURE__*/_defineComponent({
  props: {
  borderColor: {
    type: String,
    default: '#103578',
  },
  color: {
    type: String,
    default: '#fff',
  },
  backgroundColor: {
    type: String,
    default: 'transparent',
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "panel",
    style: _normalizeStyle({
      'border-color': __props.borderColor,
      color: __props.color,
      'background-color': __props.backgroundColor,
    })
  }, [
    _renderSlot(_ctx.$slots, "default"),
    _createElementVNode("img", {
      class: "top-left",
      src: require('@/assets/images/home/arrow-1.png')
    }, null, 8, _hoisted_1),
    _createElementVNode("img", {
      class: "top-right",
      src: require('@/assets/images/home/arrow-2.png')
    }, null, 8, _hoisted_2),
    _createElementVNode("img", {
      class: "bottom-right",
      src: require('@/assets/images/home/arrow-3.png')
    }, null, 8, _hoisted_3),
    _createElementVNode("img", {
      class: "bottom-left",
      src: require('@/assets/images/home/arrow-4.png')
    }, null, 8, _hoisted_4)
  ], 4))
}
}

})